import { createSelector } from '@reduxjs/toolkit';
import { OrderedMap } from 'immutable';

import { bulkWritesSelectors, type bulkWritesTypes } from 'app-components/flux/bulk-writes';
import { undoSelectors } from 'app-components/flux/undo';

import { NOTIFICATIONS_REDUCER_KEY } from './notificationsReducer';
import { notificationFromBulkWrite, notificationFromUndo } from './notificationsUtils';

// @ts-expect-error FIXME TS7053
const getStore = (state: object) => state[NOTIFICATIONS_REDUCER_KEY];

export const getNotifications = createSelector(
  (state) => getStore(state).notifications,
  undoSelectors.getUndoStack,
  bulkWritesSelectors.getPendingBulkWrites,
  (notifications, undoStack, pendingBulkWrites) => {
    const undoNotifications = OrderedMap(
      undoStack
        // @ts-expect-error FIXME TS7006
        .filter((undo) => !undo.suppressToast && !undo.deferToast)
        // @ts-expect-error FIXME TS7006
        .map((undo) => [undo.key, notificationFromUndo(undo)]),
    );
    // Merged after the undo notifications so the undo toast keeps the bottom slot it already had.
    const bulkWriteNotifications = OrderedMap(
      pendingBulkWrites.map((bulkWrite: bulkWritesTypes.BulkWrite) => {
        const notification = notificationFromBulkWrite(bulkWrite);
        return [notification.id, notification];
      }),
    );
    return (
      notifications
        .merge(undoNotifications, bulkWriteNotifications)
        // @ts-expect-error FIXME TS7006
        ?.sortBy((notification) => notification.createdAt)
        .toIndexedSeq()
        // @ts-expect-error FIXME TS7006
        .groupBy((notification) => `${notification.anchorOrigin.vertical}:${notification.anchorOrigin.horizontal}`)
        // @ts-expect-error FIXME TS7006
        .flatMap((notificationsGroup) =>
          OrderedMap(
            // @ts-expect-error FIXME TS7006
            notificationsGroup.map((notification, anchorIndex) => [
              notification.id,
              notification.merge({ anchorIndex }),
            ]),
          ),
        )
    );
  },
);

export const getNotificationById = (state: object, id: string) => getNotifications(state).get(id);
